export default __webpack_public_path__ + "static/media/16.e6db7e6c.svg";